import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import Router from './components/router/router.component';
import reportWebVitals from './reportWebVitals';
import './index.scss';

ReactDOM.render(
    <BrowserRouter>
        <Router/>
    </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
